export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string | boolean | undefined> = {},
  children: Array<Node | string> = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag)
  for (const [key, value] of Object.entries(attrs)) {
    if (value === undefined || value === false) continue
    if (key === 'className') node.setAttribute('class', String(value))
    else if (value === true) node.setAttribute(key, '')
    else node.setAttribute(key, String(value))
  }
  for (const child of children) {
    node.append(typeof child === 'string' ? document.createTextNode(child) : child)
  }
  return node
}

export function clear(node: HTMLElement): void {
  while (node.firstChild) node.removeChild(node.firstChild)
}

export function fieldLabel(text: string, required = false, forId?: string): HTMLLabelElement {
  const label = el('label', { className: 'assess-label', ...(forId ? { for: forId } : {}) }, [
    text,
    required ? el('span', { className: 'assess-required', 'aria-hidden': 'true' }, [' *']) : '',
  ])
  return label
}

export function helpText(text: string): HTMLParagraphElement {
  return el('p', { className: 'assess-help' }, [text])
}

export function errorBox(messages: string[]): HTMLDivElement {
  return el(
    'div',
    { className: 'assess-error', role: 'alert' },
    messages.map((m) => el('p', {}, [m])),
  )
}

export function optionSelect(
  id: string,
  options: Array<{ value: string; label: string }>,
  value: string,
  required = false,
): HTMLSelectElement {
  const select = el('select', {
    id,
    className: 'assess-input',
    name: id,
    ...(required ? { required: true } : {}),
  }) as HTMLSelectElement
  select.append(el('option', { value: '' }, ['Select…']))
  for (const opt of options) {
    const o = el('option', { value: opt.value }, [opt.label]) as HTMLOptionElement
    if (opt.value === value) o.selected = true
    select.append(o)
  }
  return select
}
